import { ArrowLeft } from "lucide-react";

export default function ProductFormHeader({
  productId,
  productToEdit,
  error,
  categories,
  brands,
  onClose,
}) {
  return (
    <>
      <div className="flex flex-wrap items-start gap-3 mb-5">
        <button
          type="button"
          onClick={onClose}
          className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded border border-[var(--pf-border)] bg-white text-gray-600 hover:text-brand-primary hover:border-brand-primary transition-colors"
          aria-label="Back"
        >
          <ArrowLeft size={18} />
        </button>
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.12em] text-brand-primary mb-1">
            Shop / Products
          </p>
          <h2 className="text-xl font-bold text-gray-900">
            {productId || productToEdit ? "Edit Product" : "Add Product"}
          </h2>
        </div>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4 text-sm">
          {error}
        </div>
      )}

      {((Array.isArray(categories) && categories.length === 0) ||
        (Array.isArray(brands) && brands.length === 0)) && (
        <div className="bg-amber-50 border border-amber-200 text-amber-900 px-4 py-3 rounded mb-4">
          <span className="font-semibold text-sm">Setup Required</span>
          <ul className="mt-1 ml-4 list-disc text-sm text-amber-800">
            {Array.isArray(categories) && categories.length === 0 && (
              <li>No categories available. Please add categories first.</li>
            )}
            {Array.isArray(brands) && brands.length === 0 && (
              <li>No brands available. Please add brands first.</li>
            )}
          </ul>
        </div>
      )}
    </>
  );
}
